// import { jwtDecode } from "jwt-decode";
// import React, { useEffect, useState, useRef } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import axios from "axios";

// import MapComponent from "./mapComponent";
// import Sidebar from "../pages/profilesettings/component/sidebar";
// import { useCart } from "./CartContext";

// const Navbarr = () => {
//   const baseUrl =
//     process.env.NODE_ENV === "development"
//       ? process.env.REACT_APP_BASE_URL_DEV
//       : process.env.REACT_APP_BASE_URL_PROD;

//   const baseUrl1 =
//     process.env.NODE_ENV === "development"
//       ? process.env.REACT_APP_BASE_URL_DEV1
//       : process.env.REACT_APP_BASE_URL_PROD1;
//   const location = useLocation();
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   // Whenever items are added/removed from the cart:
//   const [navbarColor, setNavbarColor] = useState("");
//   const [loggedIn, setLoggedIn] = useState(false);
//   const [userDetails, setUserDetails] = useState("");
//   const [isSticky, setIsSticky] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const dropdownRef = useRef(null);
//   const [profile, setProfile] = useState(null);

//   const token = localStorage.getItem("token");

//   const handleScroll = () => {
//     if (window.scrollY > 50) {
//       setIsSticky(true);
//     } else {
//       setIsSticky(false);
//     }
//   };

//   useEffect(() => {
//     window.addEventListener('scroll', handleScroll);
//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, []);

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (token != null) {
//       const userInfo = jwtDecode(token);
//       setUserDetails(userInfo);
//       setLoggedIn(true);
//     }

//     return () => { };
//   }, []);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setDropdownOpen(false);
//       }
//     };

//     document.addEventListener("click", handleClickOutside);

//     return () => {
//       document.removeEventListener("click", handleClickOutside);
//     };
//   }, []);

//   const handleLogout = () => {
//     localStorage.clear();
//     window.location.href = "/login";
//   };

//   const [currentLocation, setCurrentLocation] = useState(null);
//   const [locationAddress, setLocationAddress] = useState("");
//   const [isLoading, setIsLoading] = useState(true);
//   const googleApiKey = "AIzaSyB4D0HM4FufPLxwOFLQbI2-MsHA09yAnAs";

//   const getAddressFromCoordinates = async (lat, lng) => {
//     const geocodeApiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${googleApiKey}`;

//     try {
//       const response = await axios.get(geocodeApiUrl);
//       if (response.data.results && response.data.results.length > 0) {
//         const addressComponents = response.data.results[0].address_components;

//         const subLocality = addressComponents.find((component) =>
//           component.types.includes("sublocality")
//         )?.long_name;
//         const locality = addressComponents.find((component) =>
//           component.types.includes("locality")
//         )?.long_name;

//         const formattedAddress = [subLocality, locality]
//           .filter(Boolean)
//           .join(", ");

//         setLocationAddress(formattedAddress);
//         localStorage.setItem("address", formattedAddress);
//       } else {
//         setLocationAddress("No address found for this location.");
//       }
//     } catch (error) {
//       console.error("Error fetching geocode data:", error);
//       setLocationAddress("Error fetching geocode data.");
//     }
//     setIsLoading(false);
//   };

//   // Default location (Chennai)
//   const chennaiCoordinates = { lat: 13.0827, lng: 80.2707 };
//   const chennaiAddress = "Chennai, Tamil Nadu, India";

//   const getGeolocation = () => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const lat = position.coords.latitude;
//           const lng = position.coords.longitude;

//           console.log("Fetched current location:", lat, lng);

//           setCurrentLocation({ lat, lng });
//           localStorage.setItem("latitude", lat.toString());
//           localStorage.setItem("longitude", lng.toString());

//           getAddressFromCoordinates(lat, lng);
//         },
//         (error) => {
//           console.warn("Error fetching location, using default:", error);
//           setDefaultLocation();
//         }
//       );
//     } else {
//       console.warn("Geolocation not supported, using default location.");
//       setDefaultLocation();
//     }
//   };

//   const setDefaultLocation = () => {
//     setCurrentLocation(chennaiCoordinates);
//     setLocationAddress(chennaiAddress);

//     localStorage.setItem("latitude", chennaiCoordinates.lat.toString());
//     localStorage.setItem("longitude", chennaiCoordinates.lng.toString());
//     localStorage.setItem("address", chennaiAddress);

//     setIsLoading(false);
//   };





//   // 




//   // 
  
//   // Retrieve saved location from localStorage
//   useEffect(() => {
//     const savedLat = localStorage.getItem("latitude");
//     const savedLng = localStorage.getItem("longitude");
//     const savedAddress = localStorage.getItem("address");

//     console.log("Retrieved from localStorage:", savedLat, savedLng, savedAddress);

//     if (savedLat && savedLng && savedAddress) {
//       const lat = parseFloat(savedLat);
//       const lng = parseFloat(savedLng);

//       if (!isNaN(lat) && !isNaN(lng)) {
//         setCurrentLocation({ lat, lng });
//         setLocationAddress(savedAddress);
//         setIsLoading(false);
//       } else {
//         console.error("Invalid latitude or longitude values. Fetching new location.");
//         getGeolocation();
//       }
//     } else {
//       getGeolocation();
//     }
//   }, []);

//   // Handle location selection from user input
//   const handleLocationSelect = (newLocation) => {
//     if (newLocation?.lat && newLocation?.lng && newLocation?.address) {
//       console.log("User selected location:", newLocation);

//       setCurrentLocation({ lat: newLocation.lat, lng: newLocation.lng });
//       setLocationAddress(newLocation.address);

//       localStorage.setItem("latitude", newLocation.lat.toString());
//       localStorage.setItem("longitude", newLocation.lng.toString());
//       localStorage.setItem("address", newLocation.address);
//     } else {
//       console.error("Invalid location data received:", newLocation);
//     }
//   };



//   // profile
//   useEffect(() => {
//     const fetchUserDetails1 = async () => {
//       if (!token) {
//         console.error("No token found");
//         setLoading(false);
//         return;
//       }

//       try {
//         const response = await fetch(`${baseUrl}/users/getprofile
// `, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (!response.ok) throw new Error("Failed to fetch user details");

//         const data = await response.json();
//         setProfile(data.path);
//         console.log(data.path, "p")
//       } catch (error) {
//         console.error("Error fetching user details:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchUserDetails1();
//   }, [token]);



//   const { cartCount } = useCart();



//   const [keyword, setKeyword] = useState("");
//   const [results, setResults] = useState({ services: [], blogs: [], promotions: [], services1: [] });
//   const [error, setError] = useState(null);
//   const [showPopup, setShowPopup] = useState(false);

//   const handleInputChange = (e) => {
//     setKeyword(e.target.value);
//   };

//   const handleSearch = async () => {
//     if (!keyword.trim()) return;

//     const storedLatitude = localStorage.getItem("latitude");
//     const storedLongitude = localStorage.getItem("longitude");

//     if (!storedLatitude || !storedLongitude) {
//       setError("Location not found. Please enable location access.");
//       return;
//     }

//     setLoading(true);
//     setError(null);

//     try {
//       const response = await fetch(
//         `${baseUrl}/searchfilter/search?keyword=${encodeURIComponent(keyword)}&latitude=${storedLatitude}&longitude=${storedLongitude}`
//       );

//       if (!response.ok) {
//         throw new Error("Failed to fetch search results");
//       }

//       const data = await response.json();
//       setResults(data);
//       console.log(data, "search")
//       setShowPopup(true);
//     } catch (error) {
//       setError("Error fetching search results.");
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter") {
//       handleSearch();
//     }
//   };

//   const closePopup = () => {
//     setShowPopup(false);
//   };

//   const placeholderTexts = [
//     " ‘Home cleaning’",
//     "‘Facial’",
//     " ‘Women spa’",
//     " ‘AC repair’",
//     " ‘Plumber’",
//     " ‘Salon at women’",
//   ];

//   const [typedText, setTypedText] = useState("");
//   const [textIndex, setTextIndex] = useState(0);
//   const [isDeleting, setIsDeleting] = useState(false);

//   useEffect(() => {
//     const currentText = placeholderTexts[textIndex];
//     let typingSpeed = isDeleting ? 50 : 100;

//     const timeout = setTimeout(() => {
//       if (isDeleting) {
//         setTypedText((prev) => prev.slice(0, -1));
//       } else {
//         setTypedText((prev) => currentText.slice(0, prev.length + 1));
//       }

//       if (!isDeleting && typedText === currentText) {
//         setTimeout(() => setIsDeleting(true), 1000);
//       }

//       if (isDeleting && typedText === "") {
//         setIsDeleting(false);
//         setTextIndex((prev) => (prev + 1) % placeholderTexts.length);
//       }
//     }, typingSpeed);

//     return () => clearTimeout(timeout);
//   }, [typedText, isDeleting, textIndex]);


//   // const [activeItem, setActiveItem] = useState("/home"); // Add a state to track active item
//   // const handleNavigate = (path) => {
//   //   activeItem={location.pathname} onNavigate={navigate}    // navigate to the path
//   // };

//   return (
//     <>
//       <div
//         className={`${isSticky ? ' hidden lg:block overflow-x-hidden  fixed top-0 z-20 w-full border-b-2 bg-white  shadow-md  px-4 lg:px-10 lg:py-4' : 'bg-white absolute top-0 z-20 w-full overflow-x-hidden shadow-md px-4 lg:px-10 py-4'
//           }`}
//       >
//         <div className="flex flex-col lg:px-5 py-2 space-y-2 lg:space-y-0">
//           <div className={`flex lg:flex-row lg:justify-between lg:items-center font-semibold space-y-2 lg:space-y-0 py-2 ${isSticky ? 'text-[#ffff]' : ' text-[#2A668D] font-semibold'}`}>
//             <div className="text-[#000000]  hidden lg:block font-bold text-xl">
//               <Link to={"/home"}>
//                 <div className="flex">
//                   <img
//                     src="/shortlogo.png" // assuming it's in public/
//                     alt="Wehelpufirst Logo"
//                     className="vol w-[50px]  h-[50px]"
//                   />
//                   <p className="vol mt-3  text-[12px] md:text-[18px] text-[#2A668D] lg:text-[32px]  animate_animated animate_lightSpeedInLeft">
//                     Wehelpufirst
//                   </p>
//                 </div>
//               </Link>
//             </div>
//             {/* mobile */}

//             <div className="lg:hidden flex items-center ">
//               {/* <button
//                 className="text-[16px] text-[#2A668D]"
//                 onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//               >
//                 <svg
//                   className="w-8 h-8 text-[#2A668D]"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                     d="M4 6h16M4 12h16M4 18h16"
//                   />
//                 </svg>
//               </button> */}
//               <Sidebar activeItem={location.pathname} onNavigate={navigate} />

//             </div>

//             <div className="text-[#000000] ml-10  pt-2 block lg:hidden  font-bold text-xl flex-1 text-center">
//               <Link to="/home">
//                 <p className="vol text-[16px] md:text-[18px] text-[#2A668D] lg:text-[22px] animate_animated animate_lightSpeedInLeft">
//                   Wehelpufirst
//                 </p>
//               </Link>
//             </div>


//             <div className="lg:hidden flex items-center  mr-2">
//               <div className="relative">

//                 {loggedIn &&
//                   <Link to={"/home/cart"}>
//                     <div className="relative bg-transparent text-[#2A668D] rounded-[4px]">
//                       <button className="border border-[#00000040] p-2 rounded-lg shadow-lg">
//                         <svg
//                           width="20"
//                           height="20"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                           xmlns="http://www.w3.org/2000/svg"
//                         >
//                           <path
//                             d="M2.5 4.25C2.5 4.05109 2.57902 3.86032 2.71967 3.71967C2.86032 3.57902 3.05109 3.5 3.25 3.5H3.808C4.758 3.5 5.328 4.139 5.653 4.733C5.87 5.129 6.027 5.588 6.15 6.004C6.18327 6.00137 6.21663 6.00004 6.25 6H18.748C19.578 6 20.178 6.794 19.95 7.593L18.122 14.002C17.9581 14.5769 17.6114 15.0827 17.1343 15.4428C16.6572 15.803 16.0758 15.9979 15.478 15.998H9.53C8.92749 15.998 8.34165 15.8002 7.86252 15.4349C7.3834 15.0696 7.0375 14.557 6.878 13.976L6.118 11.204L4.858 6.956L4.857 6.948C4.701 6.381 4.555 5.85 4.337 5.454C4.128 5.069 3.96 5 3.809 5H3.25C3.05109 5 2.86032 4.92098 2.71967 4.78033C2.57902 4.63968 2.5 4.44891 2.5 4.25ZM7.573 10.84L8.324 13.579C8.474 14.121 8.967 14.498 9.53 14.498H15.478C15.7497 14.498 16.014 14.4095 16.2309 14.2458C16.4478 14.0821 16.6054 13.8523 16.68 13.591L18.417 7.5H6.585L7.559 10.787L7.573 10.84Z"
//                             fill="#2A668D"
//                           />
//                           <path
//                             d="M11 19C11 19.5304 10.7893 20.0391 10.4142 20.4142C10.0391 20.7893 9.53043 21 9 21C8.46957 21 7.96086 20.7893 7.58579 20.4142C7.21071 20.0391 7 19.5304 7 19C7 18.4696 7.21071 17.9609 7.58579 17.5858C7.96086 17.2107 8.46957 17 9 17C9.53043 17 10.0391 17.2107 10.4142 17.5858C10.7893 17.9609 11 18.4696 11 19ZM9.5 19C9.5 18.8674 9.44732 18.7402 9.35355 18.6464C9.25979 18.5527 9.13261 18.5 9 18.5C8.86739 18.5 8.74021 18.5527 8.64645 18.6464C8.55268 18.7402 8.5 18.8674 8.5 19C8.5 19.1326 8.55268 19.2598 8.64645 19.3536C8.74021 19.4473 8.86739 19.5 9 19.5C9.13261 19.5 9.25979 19.4473 9.35355 19.3536C9.44732 19.2598 9.5 19.1326 9.5 19Z"
//                             fill="#2A668D"
//                           />
//                           <path
//                             d="M18 19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21C15.4696 21 14.9609 20.7893 14.5858 20.4142C14.2107 20.0391 14 19.5304 14 19C14 18.4696 14.2107 17.9609 14.5858 17.5858C14.9609 17.2107 15.4696 17 16 17C16.5304 17 17.0391 17.2107 17.4142 17.5858C17.7893 17.9609 18 18.4696 18 19ZM16.5 19C16.5 18.8674 16.4473 18.7402 16.3536 18.6464C16.2598 18.5527 16.1326 18.5 16 18.5C15.8674 18.5 15.7402 18.5527 15.6464 18.6464C15.5527 18.7402 15.5 18.8674 15.5 19C15.5 19.1326 15.5527 19.2598 15.6464 19.3536C15.7402 19.4473 15.8674 19.5 16 19.5C16.1326 19.5 16.2598 19.4473 16.3536 19.3536C16.4473 19.2598 16.5 19.1326 16.5 19Z"
//                             fill="#2A668D"
//                           />
//                         </svg>

//                         {/* Conditionally display cart length */}
//                         {cartCount > 0 && (
//                           <div className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
//                             {cartCount}
//                           </div>
//                         )}
//                       </button>
//                     </div>
//                   </Link>
//                 }


//               </div>

//               {!loggedIn ? (
//                 <Link to={"/login"}><button className="  bg-opacity-[10%] text-[#2A668D] h-[40px] px-3 rounded-[4px]">
//                   Sign In
//                 </button></Link>
//               ) : null}
//             </div>

//             {loggedIn ? (

//               <div className="relative block md:hidden" >
//                 <Link to={"/home/profilesetting"}>
//                   <div
//                     className="flex items-center gap-2 rounded-full cursor-pointer"
//                   // onClick={() => setDropdownOpen(!dropdownOpen)}
//                   >
//                     <img
//                       src={`${baseUrl1}/${profile}`}
//                       alt="Profile"
//                       className="rounded-full w-[40px] h-[40px] cursor-pointer"
//                     />
//                     <p>
//                       {(() => {
//                         const fullName = userDetails?.FullName || "";
//                         const firstName = fullName.trim().split(" ")[0];

//                         return firstName.length > 10 ? firstName.slice(0, 10) + "..." : firstName;
//                       })()}
//                     </p>
//                   </div>
//                 </Link>
//               </div>) : null}





//             {isMobileMenuOpen && (
//               <div className="lg:hidden fixed top-0 left-0 w-full h-full bg-[#2A668D] text-white z-30">
//                 <div className="flex flex-col items-center justify-center space-y-4 py-12">
//                   <Link to="/home" className="text-xl text-center">
//                     Home
//                   </Link>
//                   <Link to="/user_profile" className="text-xl text-center">
//                     Profile Settings
//                   </Link>
//                   {!loggedIn ? (
//                     <button className="text-[16px] bg-[#008081] bg-opacity-[10%] text-[#ffff] h-[40px] px-3 rounded-[4px]">
//                       Sign In
//                     </button>
//                   ) : (
//                     <button
//                       className="text-[16px] text-[#ffff] h-[40px] px-3 rounded-[4px]"
//                       onClick={handleLogout}
//                     >
//                       Logout
//                     </button>
//                   )}
//                   <button
//                     className="absolute top-4 right-4 text-white text-3xl"
//                     onClick={() => setIsMobileMenuOpen(false)}
//                   >
//                     &times;
//                   </button>
//                 </div>
//               </div>
//             )}

//             {/* Desktop Menu */}
//             <div className="hidden lg:flex items-center px-10 overflow-x-hidden    space-x-3 md:space-x-6 animate_animated animate_lightSpeedInRight">
//               <div className="flex  items-center overflow-y-hidden space-x-3 md:space-x-6 animate_animated p-2.5  px-2 py-3  text-[#C9C9C9] animate_lightSpeedInRight">

//                 <div className="relative">
//                   <input
//                     type="text"
//                     value={keyword}
//                     onChange={handleInputChange}
//                     onKeyDown={handleKeyDown}
//                     className="w-[350px] px-4 py-3 border border-[#00000040] rounded-lg focus:outline-none pl-10 placeholder-[#9CA3AF]"
//                     placeholder={`Search for ${typedText}`}
//                   />
//                   {loading && (
//                     <div className="absolute right-4 top-4 text-[#11485B] text-lg animate-spin">⏳</div>
//                   )}
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="absolute left-4 top-1/2 transform -translate-y-1/2 text-[#11485B] w-5 h-5"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   >
//                     <circle cx="11" cy="11" r="8" />
//                     <line x1="21" y1="21" x2="16.65" y2="16.65" />
//                   </svg>
//                 </div>


//               </div>
//               <div className="flex items-center space-x-3 md:space-x-6 animate_animated  p-2.5 border border-[#00000040]  px-2 py-3  rounded-lg  text-[#C9C9C9]  animate_lightSpeedInRight">
//                 <MapComponent
//                   initialLocation={currentLocation}
//                   initialAddress={locationAddress}
//                   onLocationSelect={handleLocationSelect}
//                 />
//               </div>



//               {loggedIn &&
//                 <Link to={"/home/cart"}>
//                   <div className="relative bg-transparent text-[#2A668D] rounded-[4px]">
//                     <button className="border border-[#00000040] p-3 rounded-lg shadow-lg">
//                       <svg
//                         width="24"
//                         height="24"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           d="M2.5 4.25C2.5 4.05109 2.57902 3.86032 2.71967 3.71967C2.86032 3.57902 3.05109 3.5 3.25 3.5H3.808C4.758 3.5 5.328 4.139 5.653 4.733C5.87 5.129 6.027 5.588 6.15 6.004C6.18327 6.00137 6.21663 6.00004 6.25 6H18.748C19.578 6 20.178 6.794 19.95 7.593L18.122 14.002C17.9581 14.5769 17.6114 15.0827 17.1343 15.4428C16.6572 15.803 16.0758 15.9979 15.478 15.998H9.53C8.92749 15.998 8.34165 15.8002 7.86252 15.4349C7.3834 15.0696 7.0375 14.557 6.878 13.976L6.118 11.204L4.858 6.956L4.857 6.948C4.701 6.381 4.555 5.85 4.337 5.454C4.128 5.069 3.96 5 3.809 5H3.25C3.05109 5 2.86032 4.92098 2.71967 4.78033C2.57902 4.63968 2.5 4.44891 2.5 4.25ZM7.573 10.84L8.324 13.579C8.474 14.121 8.967 14.498 9.53 14.498H15.478C15.7497 14.498 16.014 14.4095 16.2309 14.2458C16.4478 14.0821 16.6054 13.8523 16.68 13.591L18.417 7.5H6.585L7.559 10.787L7.573 10.84Z"
//                           fill="#2A668D"
//                         />
//                         <path
//                           d="M11 19C11 19.5304 10.7893 20.0391 10.4142 20.4142C10.0391 20.7893 9.53043 21 9 21C8.46957 21 7.96086 20.7893 7.58579 20.4142C7.21071 20.0391 7 19.5304 7 19C7 18.4696 7.21071 17.9609 7.58579 17.5858C7.96086 17.2107 8.46957 17 9 17C9.53043 17 10.0391 17.2107 10.4142 17.5858C10.7893 17.9609 11 18.4696 11 19ZM9.5 19C9.5 18.8674 9.44732 18.7402 9.35355 18.6464C9.25979 18.5527 9.13261 18.5 9 18.5C8.86739 18.5 8.74021 18.5527 8.64645 18.6464C8.55268 18.7402 8.5 18.8674 8.5 19C8.5 19.1326 8.55268 19.2598 8.64645 19.3536C8.74021 19.4473 8.86739 19.5 9 19.5C9.13261 19.5 9.25979 19.4473 9.35355 19.3536C9.44732 19.2598 9.5 19.1326 9.5 19Z"
//                           fill="#2A668D"
//                         />
//                         <path
//                           d="M18 19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21C15.4696 21 14.9609 20.7893 14.5858 20.4142C14.2107 20.0391 14 19.5304 14 19C14 18.4696 14.2107 17.9609 14.5858 17.5858C14.9609 17.2107 15.4696 17 16 17C16.5304 17 17.0391 17.2107 17.4142 17.5858C17.7893 17.9609 18 18.4696 18 19ZM16.5 19C16.5 18.8674 16.4473 18.7402 16.3536 18.6464C16.2598 18.5527 16.1326 18.5 16 18.5C15.8674 18.5 15.7402 18.5527 15.6464 18.6464C15.5527 18.7402 15.5 18.8674 15.5 19C15.5 19.1326 15.5527 19.2598 15.6464 19.3536C15.7402 19.4473 15.8674 19.5 16 19.5C16.1326 19.5 16.2598 19.4473 16.3536 19.3536C16.4473 19.2598 16.5 19.1326 16.5 19Z"
//                           fill="#2A668D"
//                         />
//                       </svg>

//                       {/* Conditionally display cart length */}
//                       {cartCount > 0 && (
//                         <div className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
//                           {cartCount}
//                         </div>
//                       )}
//                     </button>
//                   </div>
//                 </Link>
//               }
//               {/* 
//               <button className="border border-[#00000040]  px-2 py-3  rounded-lg shadow-lg">

//                 <svg className="ml-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                   <path d="M0.5 16.3845V14.8848H2.30775V7.423C2.30775 6.07817 2.72283 4.88908 3.553 3.85575C4.383 2.82242 5.44867 2.1615 6.75 1.873V1.25C6.75 0.902833 6.87142 0.607667 7.11425 0.3645C7.35708 0.1215 7.65192 0 7.99875 0C8.34575 0 8.641 0.1215 8.8845 0.3645C9.12817 0.607667 9.25 0.902833 9.25 1.25V1.873C10.5513 2.1615 11.617 2.82242 12.447 3.85575C13.2772 4.88908 13.6923 6.07817 13.6923 7.423V14.8848H15.5V16.3845H0.5ZM7.99825 19.1923C7.50075 19.1923 7.07542 19.0153 6.72225 18.6613C6.36892 18.3073 6.19225 17.8817 6.19225 17.3845H9.80775C9.80775 17.8833 9.63058 18.3093 9.27625 18.6625C8.92192 19.0157 8.49592 19.1923 7.99825 19.1923ZM3.80775 14.8848H12.1923V7.423C12.1923 6.26533 11.783 5.27725 10.9645 4.45875C10.1458 3.64008 9.15767 3.23075 8 3.23075C6.84233 3.23075 5.85417 3.64008 5.0355 4.45875C4.217 5.27725 3.80775 6.26533 3.80775 7.423V14.8848Z" fill="#2A668D" />
//                 </svg>
//               </button> */}
//               {!loggedIn ? (
//                 <div className="border border-[#00000040]  p-1  rounded-lg shadow-lg">
//                   <Link to={"/login"}> <button className="text-[16px]  bg-opacity-[10%]  text-[#2A668D] h-[40px] px-3 rounded-[4px]">
//                     Sign In
//                   </button></Link>
//                 </div>
//               ) : null}

//               {loggedIn ? (
//                 <div className="relative" >
//                   <Link to={"/home/profilesetting"}>  <div
//                     className="flex items-center gap-4 rounded-full cursor-pointer"
//                   >
//                     <img
//                       src={`${baseUrl1}/${profile}`}
//                       alt="Profile"
//                       className="rounded-full w-[50px] h-[50px] cursor-pointer"
//                     />
//                     <p className="text-[#2A668D] ">{userDetails.FullName} </p>
//                   </div></Link>




//                 </div>
//               ) : null}
//             </div>
//           </div>
//         </div>
//       </div>



//       {showPopup && (
//         <div className="fixed z-50 left-[790px] top-[110px]  transform  -translate-x-1/2 w-[350px] max-w-md bg-white p-4 rounded-lg shadow-2xl max-h-72 overflow-auto">
//           <button
//             onClick={closePopup}
//             className="absolute top-2 right-2 text-[#11485B] hover:text-[#11485B] focus:outline-none transition"
//           >
//             ✖
//           </button>

//           <div className="mt-6">
//             {results?.services?.length > 0 && (
//               <div className="mb-4">
//                 <ul className="space-y-3">
//                   {results.services.map((service) => (<>
//                     <div className="flex gap-2">
//                       <img className="w-14 h-14 rounded-full" src={`${baseUrl1}/${service.thumbnailImages[0]}`}></img>

//                       <li key={service._id} className="px-2 py-4 rounded-md transition">
//                         <Link to={`/home/category/viewService?serviceid=${service.serviceId}`}

//                           className="text-[#11485B] text-[18px] hover:text-blue-800"
//                           onClick={closePopup}
//                         >
//                           {service.companyName}
//                         </Link>
//                       </li>
//                     </div>
//                   </>
//                   ))}
//                 </ul>
//               </div>
//             )}

//             {!loading && !error && !results?.services?.length && (
//               <p className="mt-4 text-[#11485B] text-center">No results found.</p>
//             )}
//           </div>
//         </div>
//       )}

//     </>
//   );
// };

// export default Navbarr;





import { jwtDecode } from "jwt-decode";
import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

import MapComponent from "./mapComponent";
import Sidebar from "../pages/profilesettings/component/sidebar";
import { useCart } from "./CartContext";

const Navbarr = () => {
  const baseUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV
      : process.env.REACT_APP_BASE_URL_PROD;

  const baseUrl1 =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV1
      : process.env.REACT_APP_BASE_URL_PROD1;

  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const [navbarColor, setNavbarColor] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);
  const [userDetails, setUserDetails] = useState("");
  const [isSticky, setIsSticky] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [profile, setProfile] = useState(null);

  const token = localStorage.getItem("token");

  const handleScroll = () => {
    if (window.scrollY > 50) setIsSticky(true);
    else setIsSticky(false);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token != null) {
      const userInfo = jwtDecode(token);
      setUserDetails(userInfo);
      setLoggedIn(true);
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  // ---- LOCATION STATE ----
  const [currentLocation, setCurrentLocation] = useState(null);
  const [locationAddress, setLocationAddress] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const googleApiKey = "AIzaSyB4D0HM4FufPLxwOFLQbI2-MsHA09yAnAs";

  // Default location (Chennai)
  const chennaiCoordinates = { lat: 13.0827, lng: 80.2707 };
  const chennaiAddress = "Chennai, Tamil Nadu, India";

  // If you ever want reverse geocode again, keep this helper:
  const getAddressFromCoordinates = async (lat, lng) => {
    const geocodeApiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${googleApiKey}`;
    try {
      const { data } = await axios.get(geocodeApiUrl);
      if (data?.results?.length) {
        const comps = data.results[0].address_components || [];
        const subLocality = comps.find((c) => c.types.includes("sublocality"))?.long_name;
        const locality = comps.find((c) => c.types.includes("locality"))?.long_name;
        const formattedAddress =
          [subLocality, locality].filter(Boolean).join(", ") ||
          data.results[0].formatted_address;
        setLocationAddress(formattedAddress);
        localStorage.setItem("address", formattedAddress);
      } else {
        setLocationAddress(chennaiAddress);
      }
    } catch (e) {
      console.error("Error fetching geocode data:", e);
      setLocationAddress(chennaiAddress);
    } finally {
      setIsLoading(false);
    }
  };

  // Force default location into state + localStorage
  const setDefaultLocation = () => {
    setCurrentLocation(chennaiCoordinates);
    setLocationAddress(chennaiAddress);
    localStorage.setItem("latitude", chennaiCoordinates.lat.toString());
    localStorage.setItem("longitude", chennaiCoordinates.lng.toString());
    localStorage.setItem("address", chennaiAddress);
    setIsLoading(false);
  };

  // Handle user-picked location (keep this if you still want manual override)
  const handleLocationSelect = (newLocation) => {
    if (newLocation?.lat && newLocation?.lng && newLocation?.address) {
      setCurrentLocation({ lat: newLocation.lat, lng: newLocation.lng });
      setLocationAddress(newLocation.address);
      localStorage.setItem("latitude", newLocation.lat.toString());
      localStorage.setItem("longitude", newLocation.lng.toString());
      localStorage.setItem("address", newLocation.address);
    } else {
      console.error("Invalid location data received:", newLocation);
    }
  };

  // ---- PROFILE ----
  useEffect(() => {
    const fetchUserDetails1 = async () => {
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const response = await fetch(`${baseUrl}/users/getprofile`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) throw new Error("Failed to fetch user details");
        const data = await response.json();
        setProfile(data.path);
      } catch (error) {
        console.error("Error fetching user details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUserDetails1();
  }, [token, baseUrl]);

  const { cartCount } = useCart();

  // ---- SEARCH ----
  const [keyword, setKeyword] = useState("");
  const [results, setResults] = useState({ services: [], blogs: [], promotions: [], services1: [] });
  const [error, setError] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  const handleInputChange = (e) => setKeyword(e.target.value);

  const handleSearch = async () => {
    if (!keyword.trim()) return;
    const storedLatitude = localStorage.getItem("latitude");
    const storedLongitude = localStorage.getItem("longitude");
    if (!storedLatitude || !storedLongitude) {
      setError("Location not found. Please enable location access.");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${baseUrl}/searchfilter/search?keyword=${encodeURIComponent(
          keyword
        )}&latitude=${storedLatitude}&longitude=${storedLongitude}`
      );
      if (!response.ok) throw new Error("Failed to fetch search results");
      const data = await response.json();
      setResults(data);
      setShowPopup(true);
    } catch (error) {
      setError("Error fetching search results.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSearch();
  };

  const closePopup = () => setShowPopup(false);

  // Typewriter placeholder
  const placeholderTexts = [
    " ‘Home cleaning’",
    "‘Facial’",
    " ‘Women spa’",
    " ‘AC repair’",
    " ‘Plumber’",
    " ‘Salon at women’",
  ];
  const [typedText, setTypedText] = useState("");
  const [textIndex, setTextIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentText = placeholderTexts[textIndex];
    let typingSpeed = isDeleting ? 50 : 100;
    const timeout = setTimeout(() => {
      if (isDeleting) setTypedText((prev) => prev.slice(0, -1));
      else setTypedText((prev) => currentText.slice(0, prev.length + 1));
      if (!isDeleting && typedText === currentText) {
        setTimeout(() => setIsDeleting(true), 1000);
      }
      if (isDeleting && typedText === "") {
        setIsDeleting(false);
        setTextIndex((prev) => (prev + 1) % placeholderTexts.length);
      }
    }, typingSpeed);
    return () => clearTimeout(timeout);
  }, [typedText, isDeleting, textIndex]);

  // ===============================
  // HARD-DEFAULT LOCATION ON LOAD
  // ===============================
  useEffect(() => {
    // Ignore GPS and any previously saved coordinates.
    setDefaultLocation();
  }, []);
  // ===============================

  return (
    <>
      <div
        className={`${
          isSticky
            ? " hidden lg:block overflow-x-hidden  fixed top-0 z-20 w-full border-b-2 bg-white  shadow-md  px-4 lg:px-10 lg:py-4"
            : "bg-white absolute top-0 z-20 w-full overflow-x-hidden shadow-md px-4 lg:px-10 py-4"
        }`}
      >
        <div className="flex flex-col lg:px-5 py-2 space-y-2 lg:space-y-0">
          <div
            className={`flex lg:flex-row lg:justify-between lg:items-center font-semibold space-y-2 lg:space-y-0 py-2 ${
              isSticky ? "text-[#ffff]" : " text-[#2A668D] font-semibold"
            }`}
          >
            <div className="text-[#000000]  hidden lg:block font-bold text-xl">
              <Link to={"/home"}>
                <div className="flex">
                  <img src="/shortlogo.png" alt="Wehelpufirst Logo" className="vol w-[50px]  h-[50px]" />
                  <p className="vol mt-3  text-[12px] md:text-[18px] text-[#2A668D] lg:text-[32px]  animate_animated animate_lightSpeedInLeft">
                    Wehelpufirst
                  </p>
                </div>
              </Link>
            </div>

            {/* mobile */}
            <div className="lg:hidden flex items-center ">
              <Sidebar activeItem={location.pathname} onNavigate={navigate} />
            </div>

            <div className="text-[#000000] ml-10  pt-2 block lg:hidden  font-bold text-xl flex-1 text-center">
              <Link to="/home">
                <p className="vol text-[16px] md:text-[18px] text-[#2A668D] lg:text-[22px] animate_animated animate_lightSpeedInLeft">
                  Wehelpufirst
                </p>
              </Link>
            </div>

            <div className="lg:hidden flex items-center  mr-2">
              <div className="relative">
                {loggedIn && (
                  <Link to={"/home/cart"}>
                    <div className="relative bg-transparent text-[#2A668D] rounded-[4px]">
                      <button className="border border-[#00000040] p-2 rounded-lg shadow-lg">
                        {/* cart icon */}
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.5 4.25C2.5 4.05109 2.57902 3.86032 2.71967 3.71967C2.86032 3.57902 3.05109 3.5 3.25 3.5H3.808C4.758 3.5 5.328 4.139 5.653 4.733C5.87 5.129 6.027 5.588 6.15 6.004C6.18327 6.00137 6.21663 6.00004 6.25 6H18.748C19.578 6 20.178 6.794 19.95 7.593L18.122 14.002C17.9581 14.5769 17.6114 15.0827 17.1343 15.4428C16.6572 15.803 16.0758 15.9979 15.478 15.998H9.53C8.92749 15.998 8.34165 15.8002 7.86252 15.4349C7.3834 15.0696 7.0375 14.557 6.878 13.976L6.118 11.204L4.858 6.956L4.857 6.948C4.701 6.381 4.555 5.85 4.337 5.454C4.128 5.069 3.96 5 3.809 5H3.25C3.05109 5 2.86032 4.92098 2.71967 4.78033C2.57902 4.63968 2.5 4.44891 2.5 4.25ZM7.573 10.84L8.324 13.579C8.474 14.121 8.967 14.498 9.53 14.498H15.478C15.7497 14.498 16.014 14.4095 16.2309 14.2458C16.4478 14.0821 16.6054 13.8523 16.68 13.591L18.417 7.5H6.585L7.559 10.787L7.573 10.84Z" fill="#2A668D" />
                          <path d="M11 19C11 19.5304 10.7893 20.0391 10.4142 20.4142C10.0391 20.7893 9.53043 21 9 21C8.46957 21 7.96086 20.7893 7.58579 20.4142C7.21071 20.0391 7 19.5304 7 19C7 18.4696 7.21071 17.9609 7.58579 17.5858C7.96086 17.2107 8.46957 17 9 17C9.53043 17 10.0391 17.2107 10.4142 17.5858C10.7893 17.9609 11 18.4696 11 19ZM9.5 19C9.5 18.8674 9.44732 18.7402 9.35355 18.6464C9.25979 18.5527 9.13261 18.5 9 18.5C8.86739 18.5 8.74021 18.5527 8.64645 18.6464C8.55268 18.7402 8.5 18.8674 8.5 19C8.5 19.1326 8.55268 19.2598 8.64645 19.3536C8.74021 19.4473 8.86739 19.5 9 19.5C9.13261 19.5 9.25979 19.4473 9.35355 19.3536C9.44732 19.2598 9.5 19.1326 9.5 19Z" fill="#2A668D" />
                          <path d="M18 19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21C15.4696 21 14.9609 20.7893 14.5858 20.4142C14.2107 20.0391 14 19.5304 14 19C14 18.4696 14.2107 17.9609 14.5858 17.5858C14.9609 17.2107 15.4696 17 16 17C16.5304 17 17.0391 17.2107 17.4142 17.5858C17.7893 17.9609 18 18.4696 18 19ZM16.5 19C16.5 18.8674 16.4473 18.7402 16.3536 18.6464C16.2598 18.5527 16.1326 18.5 16 18.5C15.8674 18.5 15.7402 18.5527 15.6464 18.6464C15.5527 18.7402 15.5 18.8674 15.5 19C15.5 19.1326 15.5527 19.2598 15.6464 19.3536C15.7402 19.4473 15.8674 19.5 16 19.5C16.1326 19.5 16.2598 19.4473 16.3536 19.3536C16.4473 19.2598 16.5 19.1326 16.5 19Z" fill="#2A668D" />
                        </svg>
                        {cartCount > 0 && (
                          <div className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
                            {cartCount}
                          </div>
                        )}
                      </button>
                    </div>
                  </Link>
                )}
              </div>

              {!loggedIn ? (
                <Link to={"/login"}>
                  <button className="  bg-opacity-[10%] text-[#2A668D] h-[40px] px-3 rounded-[4px]">Sign In</button>
                </Link>
              ) : null}
            </div>

            {loggedIn ? (
              <div className="relative block md:hidden">
                <Link to={"/home/profilesetting"}>
                  <div className="flex items-center gap-2 rounded-full cursor-pointer">
                    <img src={`${baseUrl1}/${profile}`} alt="Profile" className="rounded-full w-[40px] h-[40px] cursor-pointer" />
                    <p>
                      {(() => {
                        const fullName = userDetails?.FullName || "";
                        const firstName = fullName.trim().split(" ")[0];
                        return firstName.length > 10 ? firstName.slice(0, 10) + "..." : firstName;
                      })()}
                    </p>
                  </div>
                </Link>
              </div>
            ) : null}

            {isMobileMenuOpen && (
              <div className="lg:hidden fixed top-0 left-0 w-full h-full bg-[#2A668D] text-white z-30">
                <div className="flex flex-col items-center justify-center space-y-4 py-12">
                  <Link to="/home" className="text-xl text-center">Home</Link>
                  <Link to="/user_profile" className="text-xl text-center">Profile Settings</Link>
                  {!loggedIn ? (
                    <button className="text-[16px] bg-[#008081] bg-opacity-[10%] text-[#ffff] h-[40px] px-3 rounded-[4px]">
                      Sign In
                    </button>
                  ) : (
                    <button className="text-[16px] text-[#ffff] h-[40px] px-3 rounded-[4px]" onClick={handleLogout}>
                      Logout
                    </button>
                  )}
                  <button className="absolute top-4 right-4 text-white text-3xl" onClick={() => setIsMobileMenuOpen(false)}>
                    &times;
                  </button>
                </div>
              </div>
            )}

            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center px-10 overflow-x-hidden space-x-3 md:space-x-6 animate_animated animate_lightSpeedInRight">
              <div className="flex items-center overflow-y-hidden space-x-3 md:space-x-6 animate_animated p-2.5 px-2 py-3 text-[#C9C9C9] animate_lightSpeedInRight">
                <div className="relative">
                  <input
                    type="text"
                    value={keyword}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    className="w-[350px] px-4 py-3 border border-[#00000040] rounded-lg focus:outline-none pl-10 placeholder-[#9CA3AF]"
                    placeholder={`Search for ${typedText}`}
                  />
                  {loading && <div className="absolute right-4 top-4 text-[#11485B] text-lg animate-spin">⏳</div>}
                  <svg xmlns="http://www.w3.org/2000/svg" className="absolute left-4 top-1/2 transform -translate-y-1/2 text-[#11485B] w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="11" cy="11" r="8" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                  </svg>
                </div>
              </div>

              <div className="flex items-center space-x-3 md:space-x-6 animate_animated p-2.5 border border-[#00000040] px-2 py-3 rounded-lg text-[#C9C9C9] animate_lightSpeedInRight">
                <MapComponent
                  initialLocation={currentLocation}
                  initialAddress={locationAddress}
                  onLocationSelect={handleLocationSelect} // keep to allow manual override
                />
              </div>

              {loggedIn && (
                <Link to={"/home/cart"}>
                  <div className="relative bg-transparent text-[#2A668D] rounded-[4px]">
                    <button className="border border-[#00000040] p-3 rounded-lg shadow-lg">
                      {/* cart icon duplicated for desktop */}
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.5 4.25C2.5 4.05109 2.57902 3.86032 2.71967 3.71967C2.86032 3.57902 3.05109 3.5 3.25 3.5H3.808C4.758 3.5 5.328 4.139 5.653 4.733C5.87 5.129 6.027 5.588 6.15 6.004C6.18327 6.00137 6.21663 6.00004 6.25 6H18.748C19.578 6 20.178 6.794 19.95 7.593L18.122 14.002C17.9581 14.5769 17.6114 15.0827 17.1343 15.4428C16.6572 15.803 16.0758 15.9979 15.478 15.998H9.53C8.92749 15.998 8.34165 15.8002 7.86252 15.4349C7.3834 15.0696 7.0375 14.557 6.878 13.976L6.118 11.204L4.858 6.956L4.857 6.948C4.701 6.381 4.555 5.85 4.337 5.454C4.128 5.069 3.96 5 3.809 5H3.25C3.05109 5 2.86032 4.92098 2.71967 4.78033C2.57902 4.63968 2.5 4.44891 2.5 4.25ZM7.573 10.84L8.324 13.579C8.474 14.121 8.967 14.498 9.53 14.498H15.478C15.7497 14.498 16.014 14.4095 16.2309 14.2458C16.4478 14.0821 16.6054 13.8523 16.68 13.591L18.417 7.5H6.585L7.559 10.787L7.573 10.84Z" fill="#2A668D" />
                        <path d="M11 19C11 19.5304 10.7893 20.0391 10.4142 20.4142C10.0391 20.7893 9.53043 21 9 21C8.46957 21 7.96086 20.7893 7.58579 20.4142C7.21071 20.0391 7 19.5304 7 19C7 18.4696 7.21071 17.9609 7.58579 17.5858C7.96086 17.2107 8.46957 17 9 17C9.53043 17 10.0391 17.2107 10.4142 17.5858C10.7893 17.9609 11 18.4696 11 19ZM9.5 19C9.5 18.8674 9.44732 18.7402 9.35355 18.6464C9.25979 18.5527 9.13261 18.5 9 18.5C8.86739 18.5 8.74021 18.5527 8.64645 18.6464C8.55268 18.7402 8.5 18.8674 8.5 19C8.5 19.1326 8.55268 19.2598 8.64645 19.3536C8.74021 19.4473 8.86739 19.5 9 19.5C9.13261 19.5 9.25979 19.4473 9.35355 19.3536C9.44732 19.2598 9.5 19.1326 9.5 19Z" fill="#2A668D" />
                        <path d="M18 19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21C15.4696 21 14.9609 20.7893 14.5858 20.4142C14.2107 20.0391 14 19.5304 14 19C14 18.4696 14.2107 17.9609 14.5858 17.5858C14.9609 17.2107 15.4696 17 16 17C16.5304 17 17.0391 17.2107 17.4142 17.5858C17.7893 17.9609 18 18.4696 18 19ZM16.5 19C16.5 18.8674 16.4473 18.7402 16.3536 18.6464C16.2598 18.5527 16.1326 18.5 16 18.5C15.8674 18.5 15.7402 18.5527 15.6464 18.6464C15.5527 18.7402 15.5 18.8674 15.5 19C15.5 19.1326 15.5527 19.2598 15.6464 19.3536C15.7402 19.4473 15.8674 19.5 16 19.5C16.1326 19.5 16.2598 19.4473 16.3536 19.3536C16.4473 19.2598 16.5 19.1326 16.5 19Z" fill="#2A668D" />
                      </svg>
                      {cartCount > 0 && (
                        <div className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
                          {cartCount}
                        </div>
                      )}
                    </button>
                  </div>
                </Link>
              )}

              {!loggedIn ? (
                <div className="border border-[#00000040] p-1 rounded-lg shadow-lg">
                  <Link to={"/login"}>
                    <button className="text-[16px] bg-opacity-[10%] text-[#2A668D] h-[40px] px-3 rounded-[4px]">
                      Sign In
                    </button>
                  </Link>
                </div>
              ) : null}

              {loggedIn ? (
                <div className="relative">
                  <Link to={"/home/profilesetting"}>
                    <div className="flex items-center gap-4 rounded-full cursor-pointer">
                      <img src={`${baseUrl1}/${profile}`} alt="Profile" className="rounded-full w-[50px] h-[50px] cursor-pointer" />
                      <p className="text-[#2A668D] ">{userDetails.FullName} </p>
                    </div>
                  </Link>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      {showPopup && (
        <div className="fixed z-50 left-[790px] top-[110px] transform -translate-x-1/2 w-[350px] max-w-md bg-white p-4 rounded-lg shadow-2xl max-h-72 overflow-auto">
          <button onClick={closePopup} className="absolute top-2 right-2 text-[#11485B] hover:text-[#11485B] focus:outline-none transition">
            ✖
          </button>
          <div className="mt-6">
            {results?.services?.length > 0 && (
              <div className="mb-4">
                <ul className="space-y-3">
                  {results.services.map((service) => (
                    <div key={service._id} className="flex gap-2">
                      <img className="w-14 h-14 rounded-full" src={`${baseUrl1}/${service.thumbnailImages[0]}`} alt="" />
                      <li className="px-2 py-4 rounded-md transition">
                        <Link
                          to={`/home/category/viewService?serviceid=${service.serviceId}`}
                          className="text-[#11485B] text-[18px] hover:text-blue-800"
                          onClick={closePopup}
                        >
                          {service.companyName}
                        </Link>
                      </li>
                    </div>
                  ))}
                </ul>
              </div>
            )}
            {!loading && !error && !results?.services?.length && (
              <p className="mt-4 text-[#11485B] text-center">No results found.</p>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Navbarr;
